export default "__VITE_ASSET__0fe35601__"